import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentFormComponent } from '../document-form/document-form.component';
import {Document, DocumentService} from '../../../common/services';
import {PubSubService} from '../../../common/services/pub-sub.service';
import {typeEvents} from '../../../common/enum/type-events';

@Component({
  selector: 'p8-bdc-document-edit',
  templateUrl: './document-edit.component.html',
  styleUrls: ['./document-edit.component.scss']
})
export class DocumentEditComponent implements OnInit {
  @ViewChild(DocumentFormComponent) documentFormComponent: DocumentFormComponent;

  document: Document;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private pubSubService: PubSubService,
    private documentService: DocumentService
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      if ('id' in params) {
        this.documentService.get(params['id']).subscribe((doc: Document) => {
          this.document = doc;
        });
      }
    });
  }

  onSubmit() {
    this.documentFormComponent.patch(this.document.id).subscribe(page => {
      this.pubSubService.publish(typeEvents.docSaved, 'Les informations du document ont bien été modifiées');
      // this.router.navigate(['..'], {relativeTo: this.activatedRoute});
    });
  }

  onCancel() {
    this.router.navigate(['../..'], {relativeTo: this.activatedRoute});
  }


}
